import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import SessionsList from './SessionsList';
import Session from './Session';
import AdminSessionEngineRoute from '../../NativeSession/AdminSessionEngineRoute';

const Sessions = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <SessionsList />
      </Route>
      <Route path={`${path}/:session_id`}>
        <AdminSessionEngineRoute legacy={<Session />} />
      </Route>
      <Redirect to={`${path}`} />;
    </Switch>
  );
};

export default Sessions;
